








































import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const auth = namespace('auth');

// Components
import BaseInputCheckbox from '@components/common/BaseInputCheckbox.vue';

// Icons
import iconDrag from '@/assets/img/icon-drag.svg';
import iconTrash from '@/assets/img/icon-trash.svg';

@Component({
  components: {
    BaseInputCheckbox,
  },
})
export default class QuestionListItemAction extends Vue {
  @auth.State('currentUser') currentUser: any;

  @Prop(Boolean) required: boolean;
  @Prop(Boolean) hiddenIconDrag: boolean;
  @Prop(Boolean) hiddenIconDelete: boolean;
  @Prop(Boolean) readOnlyCheckboxRequired: boolean;

  get isNotSuperAdmin() {
    return !this.currentUser?.isSuperAdminRole;
  }

  get iconDrag() {
    return iconDrag;
  }

  get iconTrash() {
    return iconTrash;
  }
}
